import queryString from "query-string";
import {
  setDealsCopy,
  updateDealCopy,
  removeDealCopy,
  addDealCopy,
} from "./appifyActions";
import { privateFetch } from "apis";
import { removeEmptyParams, SecureLocalStorage } from "helpers";

// Deal Action Dispatchers
export const setDeals = (deals) => ({
  type: "SET_DEALS",
  deals,
});

export const removeDeals = () => ({
  type: "REMOVE_DEALS",
});

export const removeDeal = (deal) => ({
  type: "REMOVE_DEAL",
  deal,
});

export const updateDeal = (deal) => ({
  type: "UPDATE_DEAL",
  deal,
});

export const addTempDeal = () => ({
  type: "ADD_TEMP_DEAL",
});

export const removeTempDeal = (id) => ({
  type: "REMOVE_TEMP_DEAL",
});

export const updateTempDeal = (deal) => ({
  type: "UPDATE_TEMP_DEAL",
  deal,
});

// GET all deals associated with an appId
export const getDeals = (appId) => (dispatch) => {
  const userId = SecureLocalStorage.getItem("userId");
  const url =
    __BASE_API_URL__ +
    `/userDeals?dealsExpiredInLastXDays&=100000&appId=${appId}&userId=${userId}`;

  return privateFetch(url, {
    method: "GET",
  }).then((deals) => {
    dispatch(setDeals(deals));
    dispatch(setDealsCopy(deals));
    return deals;
  });
};

// Save a deal
export const createDeal = (deal) => async (dispatch) => {
  const newDeal = await postDeal(deal);
  dispatch(updateTempDeal(newDeal));
  dispatch(addDealCopy(newDeal));
  return newDeal;
};

// POST a Deal to the database
const postDeal = (deal) => {
  const queryParams = queryString.stringify(deal);
  // const queryParams = queryString.stringify(removeEmptyParams(deal));
  const url = __BASE_API_URL__ + `/deal?${queryParams}`;

  return privateFetch(url, {
    method: "POST",
  }).then((deal) => {
    return deal;
  });
};

// UPDATE a Deal
export const putDeal = (deal) => (dispatch) => {
  const queryParams = queryString.stringify(deal);
  // const queryParams = queryString.stringify(removeEmptyParams(deal));
  const url = __BASE_API_URL__ + `/deal/${deal.id}?${queryParams}`;

  return privateFetch(url, {
    method: "PUT",
  }).then((deal) => {
    dispatch(updateDeal(deal));
    dispatch(updateDealCopy(deal));
    return deal;
  });
};

// DELETE a Deal in database
export const deleteDeal = (deal) => (dispatch) => {
  const url = __BASE_API_URL__ + `/deal/${deal.id}`;

  return privateFetch(url, {
    method: "DELETE",
  }).then((res) => {
    if (res) {
      const newDeal = Object.assign({}, deal);
      newDeal.retired = 1;
      dispatch(updateDeal(newDeal));
      dispatch(updateDealCopy(newDeal));
    }
  });
};
